import React, { Component } from 'react'
import InstanciaBasicConAdjunto from './InstanciaBasicConAdjunto.js'
import {FormattedMessage, injectIntl} from 'react-intl';


class InstanciaAdjunto extends InstanciaBasicConAdjunto {
	constructor(props) {
		super(props);
  }

	render() {
      return (
        <React.Fragment>
					<div className="form-control">
							<input
								disabled={this.props.disabled || this.props.previsualizacion}
								type="file"
								{...(this.props.accept && { accept: this.props.accept })}
								multiple
								onChange={(e)=>this.handleInputChange(e, this.props.intl)}
							/>
							{this.state.adjuntoArray && this.state.adjuntoUrlArray && this.state.adjuntoArray.length > 0 && this.state.adjuntoUrlArray.length > 0 && this.state.adjuntoUrlArray.map((url, i) => 
								<button
									key={i}
									className="action btn btn-icon text-fleet btn-sm btn-dt-grid"
									onClick={(e) => this.handleOpenAdjunto(e, url)}
									title="Ver Adjunto" >
										<i className="fa fa-paperclip fa-xs"></i>
										<p>{this.state.adjuntoArray[i].archivoNombre}</p>
								</button>)}
							{/* VEC-3783 (review): fallback de solo-lectura para cuando todavía no hay
								adjuntoUrlArray (blob no disponible). Si ya está poblado, el bloque de
								arriba ya lo renderiza -- sin este chequeo, un documento histórico en
								viewOnly (ej. FormularioViewPDF) aparecía duplicado. */}
							{this.state.adjuntoArray && this.props.viewOnly && this.state.adjuntoArray.length > 0 && this.state.adjuntoUrlArray.length === 0 && this.state.adjuntoArray.map((url, i) =>
								<button
									key={i}
									className="action btn btn-icon text-fleet btn-sm btn-dt-grid"
									title="Ver Adjunto" >
										<i className="fa fa-paperclip fa-xs"></i>
										<p>{this.state.adjuntoArray[i].archivoNombre}</p>
								</button>)}
							{this.state.adjunto && (
								<>
									<hr/>
									
									{this.state.adjunto_url &&
										<button
										className="action btn btn-icon text-fleet btn-sm btn-dt-grid"
										onClick={(e) => this.handleOpenAdjunto(e)}
										title="Ver Adjunto" >
											<i className="fa fa-paperclip fa-xs"></i>
										</button>
									}
									<label className="btn-sm">{this.state.adjunto.archivoNombre}</label>
									{! this.props.disabled &&
										<button
											className="action btn btn-icon text-fleet text-danger btn-sm btn-dt-grid pull-right"
											onClick={(e) => this.handleChangeAndUpdateFather(null)}
											title="Eliminar" >
												<i className="fa fa-trash fa-xs"></i>
										</button>
									}
								</>
							)}
					</div>
					{this.state.adjuntoArray.length == 0 && ( 
					<small><FormattedMessage id='instanciaAdjunto.tamano_maximo_de_archivo' defaultMessage='Tamaño máximo de archivo 20MB.'/></small>
					)}
        </React.Fragment>
      )
  }
}

export default injectIntl(InstanciaAdjunto);
